import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { get } from 'lodash';
import {
  shopPath,
  shopFeedbackPath,
  shopInfoPath,
} from '../../shared/url_helpers';

import SharedTabs from '@reverbdotcom/commons/src/components/shared_tabs';
import SharedTab from '@reverbdotcom/commons/src/components/shared_tab';
import { CoreShopContainer } from '../../../schemas/rql';

interface Props {
  shop: CoreShopContainer.Shop;
  listingCount: number;
}

export const ShopTabsFragment = gql`
  fragment ShopTabsFragment on Shop {
    _id
    user {
      _id
      feedbackSummary {
        rollingRatingPercentage
        receivedCount
      }
    }
  }
`;

export default class ShopTabs extends React.Component<Props, null> {
  get isLoaded(): boolean {
    return !!this.props.shop;
  }

  get starRating(): number {
    return get(this.props.shop, 'user.feedbackSummary.rollingRatingPercentage') / 100;
  }

  renderPlaceholder() {
    return (
      <SharedTabs
        withWrapper
        highContrast
      >
        <SharedTab
          text={I18n.t('discovery.shop.tabs.listings')}
          url="#"
        />
        <SharedTab
          text={I18n.t('discovery.shop.tabs.feedback')}
          url="#"
        />
        <SharedTab
          text={I18n.t('discovery.shop.tabs.info')}
          url="#"
        />
      </SharedTabs>
    );
  }

  render() {
    if (!this.isLoaded) return this.renderPlaceholder();

    const { shop } = this.props;
    const { slug } = shop;

    return (
      <SharedTabs
        withWrapper
        highContrast
      >
        <SharedTab
          text={I18n.t('discovery.shop.tabs.listings')}
          url={shopPath.expand({ slug })}
          count={I18n.toNumber(this.props.listingCount, { precision: 0 })}
          indexLink
        />
        <SharedTab
          url={shopFeedbackPath.expand({ slug })}
          text={I18n.t('discovery.shop.tabs.feedback')}
          starRating={this.starRating}
          count={I18n.toNumber(
            get(this.props.shop, 'user.feedbackSummary.receivedCount'),
            { precision: 0 },
          )}
        />
        <SharedTab
          url={shopInfoPath.expand({ slug })}
          text={I18n.t('discovery.shop.tabs.info')}
        />
      </SharedTabs>
    );
  }
}
